"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { buildShopQueryParams } from "@/app/[domain]/(minimal-layout)/shop/_utilities/build-shop-query-params";
import { ProductCard } from "@/components/ProductCard/ProductCard.component";
import { calculateYearlyProductDiscount } from "@/components/ProductPageContainer/_utilities/calculate-yearly-product-discount";
import { Translation } from "@/components/Translation/Translation.component";
import { usePaywall } from "@/contexts/paywall/paywall.context";
type YearlyProductProps = {
  readonly className?: string;
  readonly size?: "small" | "medium" | "large" | "default";
  readonly variant?: "primary" | "default" | "subtle";
  readonly position?: string;
  readonly promoPosition?: string;
};
export function YearlyProduct(t0) {
  const $ = _c(31);
  const {
    className,
    size,
    position,
    promoPosition
  } = t0;
  const {
    quarterlyProduct,
    yearlyProduct,
    redirectUrl,
    articleId
  } = usePaywall();
  const t1 = yearlyProduct?.id || null;
  const t2 = promoPosition || null;
  let t3;
  if ($[0] !== articleId || $[1] !== redirectUrl || $[2] !== t1 || $[3] !== t2) {
    t3 = buildShopQueryParams({
      articleId,
      productId: t1,
      promoPosition: t2,
      redirectUrl
    });
    $[0] = articleId;
    $[1] = redirectUrl;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const yearlyProductQueryParams = t3;
  const url = `/shop/checkout/billing-details${yearlyProductQueryParams !== "" ? `?${yearlyProductQueryParams}` : ""}`;
  if (!yearlyProduct) {
    return null;
  }
  let t4;
  if ($[5] !== quarterlyProduct || $[6] !== yearlyProduct) {
    t4 = quarterlyProduct !== null && yearlyProduct !== null ? calculateYearlyProductDiscount(quarterlyProduct.price, yearlyProduct.price) : null;
    $[5] = quarterlyProduct;
    $[6] = yearlyProduct;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const discountPrice = t4;
  let t5;
  if ($[8] !== className) {
    t5 = clsx(className, "relative flex hover:z-10");
    $[8] = className;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      da: "K\xF8b nu",
      de: "Jetzt kaufen",
      en: "Buy now",
      no: "Kj\xF8p n\xE5",
      sv: "K\xF6p nu"
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      da: "\xC5rlig betaling",
      de: "J\xE4hrliche Zahlung",
      en: "Yearly payment",
      no: "\xC5rlig betaling",
      sv: "\xC5rlig betalning"
    };
    t8 = {
      da: "\xE5r",
      de: "Jahr",
      en: "year",
      no: "\xE5r",
      sv: "\xE5r"
    };
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      da: "Personligt abonnement",
      de: "Pers\xF6nliches Abonnement",
      en: "Personal subscription",
      no: "Personlig abonnement",
      sv: "Personligt abonnemang"
    };
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== yearlyProduct.id) {
    t10 = {
      contentId: yearlyProduct.id,
      contentSource: "paywall",
      contentType: "cta"
    };
    $[14] = yearlyProduct.id;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== position || $[17] !== t10 || $[18] !== url || $[19] !== yearlyProduct) {
    t11 = {
      buttonTranslations: t6,
      footNoteStarCount: 1,
      periodHeadingTranslations: t7,
      periodTranslations: t8,
      position,
      product: yearlyProduct,
      testId: "yearly-product-id",
      titleTranslations: t9,
      trackingModel: t10,
      url,
      variant: "primary"
    };
    $[16] = position;
    $[17] = t10;
    $[18] = url;
    $[19] = yearlyProduct;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== discountPrice) {
    t12 = discountPrice !== null ? <div className="absolute -top-4 -right-1 z-9 flex h-8 w-8 rotate-12 flex-col items-center justify-center gap-0.25 rounded-full border-2 border-white bg-primary text-sm text-white leading-none" data-testid="yearly-discount-badge"><span><Translation da="Spar" de="" en="Save" no="Spar" sv="Spara" /></span><span>{discountPrice}%</span><span><Translation da="" de="sparen" en="" no="" sv="" /></span></div> : null;
    $[21] = discountPrice;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <p className="text-sm"><Translation da={"Fuld adgang for \xE9n person"} de={"Voller Zugang f\xFCr eine Person"} en="Full access for one person" no={"Full tilgang for \xE9n person"} sv={"Full tillg\xE5ng f\xF6r en person"} /></p>;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== size || $[25] !== t11 || $[26] !== t12) {
    t14 = <ProductCard model={t11} size={size}>{t12}{t13}</ProductCard>;
    $[24] = size;
    $[25] = t11;
    $[26] = t12;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14 || $[29] !== t5) {
    t15 = <div className={t5}>{t14}</div>;
    $[28] = t14;
    $[29] = t5;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  return t15;
}